export default __webpack_public_path__ + "static/media/Tony.94052475.png";